import React, { useState } from 'react';
import {
  Space,
  Text,
  Button,
  Popup,
  Conditional,
} from '@cashfree-intl/coherent';
import CustomIcon from 'components/CustomIcons';
import InlineLoader from 'components/InlineLoader';
import { CURRENCY_SYMBOL } from 'utils/constants';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ACTIVE, ACTIVE_FEE_WALLET_INFO, ADD_TO_WALLET, FEE_WALLET, IN_ACTIVE, MIN_BALANCE_AMOUNT, ON_HOLD_FREE_WALLET_INFO } from '../constants';
import {
  StyledFeeWalletLowBalanceSpace,
  StyledRefreshText,
  StyledWalletCardDivision,
  StyledWalletCardPaper,
} from '../styled';
import AddToWallet from 'components/AddToWallet/AddToWallet';
import { IFeeWallet } from '../types';

const FeeWallet = ({
  status,
  balance,
  handleRefreshClick,
  handleAddMoneyToWalletClick,
  bankDetails,
  getWalletInfo,
}: IFeeWallet) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [activeModal, setActiveModal] = useState<string>('');
  const [activeModalData, setActiveModalData] = useState<any>({});

  const { pathname } = location;

  const handleWalletCardClick = walletType => () => {
    const env = searchParams.get('env') || '';
    navigate(
      `${pathname}/wallet-details?walletType=${walletType}${
        env ? `&env=${env}` : ''
      }`,
    );
  };

  const addMoneyClickHandler = (walletType: string) => (
    e: React.SyntheticEvent,
  ) => {
    // e.stopPropagation();
    setActiveModal(ADD_TO_WALLET);
    setActiveModalData({ walletType, bankDetails });
    handleAddMoneyToWalletClick(FEE_WALLET);
  };

  const closeModal = () => {
    setActiveModal('');
    setActiveModalData({});
    getWalletInfo();
  };

  return (
    <>
     <Conditional
        if={
          activeModal === ADD_TO_WALLET && Object.keys(bankDetails).length > 1
        }
      >
        <AddToWallet
          open={activeModal === ADD_TO_WALLET}
          walletType={activeModalData?.walletType}
          closeModal={closeModal}
          isWalletsIntro={false}
          bankDetails={bankDetails}
          getWalletInfo={getWalletInfo}
        />
      </Conditional>
      <StyledWalletCardPaper
        className="px-4 py-4 pointer"
        onClick={handleWalletCardClick(FEE_WALLET)}
      >
        <Space justifyContent="space-between">
          <Space gap={2} alignItems="center">
            <Space gap={1}>
              <CustomIcon componentName="FEE_WALLET" />
              <Text variant="h20">Fee Wallet</Text>
            </Space>
            <Conditional if={balance && balance < MIN_BALANCE_AMOUNT}>
              <StyledFeeWalletLowBalanceSpace gap={1} alignItems="center">
                <CustomIcon
                  componentName="INFO"
                  fill="var(--DANGER)"
                  height="0.625rem"
                  width="0.625rem"
                />
                <Text color="danger" size="b12">
                  Low Balance
                </Text>
              </StyledFeeWalletLowBalanceSpace>
            </Conditional>
          </Space>
          <Space gap={1} alignItems="center">
            <Text variant="b12">Postpaid Billing</Text>
            <Conditional if={status !== IN_ACTIVE}>
              <Popup
                content={status === ACTIVE ? ACTIVE_FEE_WALLET_INFO : ON_HOLD_FREE_WALLET_INFO}
                trigger={
                  <span className="pointer">
                    <CustomIcon componentName="INFO" />
                  </span>
                }
                position="top center"
              />
            </Conditional>
          </Space>
        </Space>
        <Text variant="b12" color="bodyLight" className="mt-1 ml-4">
          Keep sufficient funds to deduct fee charges from this wallet.
        </Text>
        <Conditional if={status === ACTIVE}>
          <Text variant="b12" className="ml-4 mt-1">
            All fee charges are deducted from your fee wallet.
          </Text>
        </Conditional>
        <StyledWalletCardDivision className="mb-2 mt-2" />
        <div className="ml-4">
          <Text variant="b12" color="bodyLight" className="mb-1">
            Wallet Balance
          </Text>
          <Space justifyContent="space-between">
            <InlineLoader
              loading={!balance}
              content={
                <Text variant="h28">
                  {CURRENCY_SYMBOL.INR} {balance || '0'}
                </Text>
              }
            />
            <Space gap={1} alignItems="center" onClick={handleRefreshClick}>
              <CustomIcon componentName="REFRESH" />
              <StyledRefreshText className="b12" color="primary">
                Refresh
              </StyledRefreshText>
            </Space>
          </Space>
          <Button
            primary
            size="small"
            className="mt-2"
            data-event-name="Add_Money"
            data-ignore-inner-text="true"
            onClick={addMoneyClickHandler('Fee Wallet')}
            disabled={status === 'IN_ACTIVE'}
          >
            Add money
          </Button>
        </div>
      </StyledWalletCardPaper>
    </>
  );
};

export default FeeWallet;
